// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/user/layouts/Header/Header.scss
// module id = 818
// module chunks = 0